//useTryOnSession.ts — binds the plain-TS controller to React

import { useEffect, useRef, useSyncExternalStore } from 'react'
import { TryOnController, type TryOnState } from './tryOnController'

export interface TryOnSession {
	readonly state: TryOnState
	readonly controller: TryOnController
}

export function useTryOnSession(): TryOnSession {
	//One controller for the lifetime of the mount. It owns media handles, so it must not be
	//rebuilt on re-render.
	const ref = useRef<TryOnController | null>(null)
	ref.current ??= new TryOnController()
	const controller = ref.current

	const state = useSyncExternalStore(controller.subscribe, controller.getSnapshot)

	useEffect(() => {
		void controller.startPreview()
		return () => {
			void controller.dispose()
		}
	}, [controller])

	return { state, controller }
}
